import React from 'react';
import { Instagram, Gift, Calendar, MapPin, Crown, Trophy, Sparkles, Share2, MessageCircle } from 'lucide-react';

// Facebook Post (1200x630) - Landscape Poster
const FacebookPoster = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
      <div 
        className="relative bg-gradient-to-r from-[#0f1219] via-[#141a24] to-[#0f1219] overflow-hidden"
        style={{ 
          width: '600px', 
          height: '315px',
          fontFamily: "'Inter', sans-serif"
        }}
      >
        {/* Gold Glow Effects */}
        <div className="absolute top-0 left-1/3 w-[250px] h-[200px] bg-[#FFD700]/10 rounded-full blur-[60px]" />
        <div className="absolute bottom-0 right-1/4 w-[150px] h-[150px] bg-[#FFD700]/5 rounded-full blur-[50px]" />
        
        {/* Confetti Decorations */}
        <div className="absolute top-8 left-8 w-1.5 h-1.5 bg-[#FFD700] rotate-45" />
        <div className="absolute top-12 right-16 w-2 h-2 bg-[#8B9A46] rounded-full" />
        <div className="absolute bottom-12 left-16 w-1.5 h-1.5 bg-[#A4B55C] rotate-12" />
        <div className="absolute bottom-8 right-24 w-1 h-1 bg-[#FFD700] rounded-full" />
        <div className="absolute top-20 left-24 w-1 h-1 bg-[#FFD700]/40" />
        
        {/* Content Container */}
        <div className="relative z-10 h-full flex items-center justify-between px-8 py-5">
          
          {/* Left Side - Main Content */}
          <div className="flex-1 pr-4">
            {/* Logo */}
            <div className="flex items-center mb-3">
              <img 
                src="https://www.kingofit.ca/images/logo.png" 
                alt="King of IT"
                className="h-6"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="hidden items-center gap-1">
                <Crown className="w-4 h-4 text-[#FFD700]" />
                <span className="font-bold text-sm text-white tracking-wider">KING<span className="text-[#FFD700]">of</span>IT</span>
              </div>
            </div>
            
            {/* Giveaway Badge */}
            <div className="inline-flex items-center gap-1 bg-[#FFD700]/20 px-2 py-1 rounded-full border border-[#FFD700]/40 mb-2">
              <Sparkles className="w-2.5 h-2.5 text-[#FFD700]" />
              <span className="text-[#FFD700] font-semibold text-[8px] tracking-wide">EXCLUSIVE GIVEAWAY</span>
            </div>
            
            {/* Main Headline */}
            <h1 className="font-black text-2xl text-white leading-none tracking-tight mb-0.5" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
              YOU COULD
            </h1>
            <h1 className="font-black text-4xl leading-none tracking-tight mb-3" style={{ fontFamily: "'Bebas Neue', sans-serif", background: 'linear-gradient(135deg, #FFD700, #FFA500)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              WIN BIG!
            </h1>
            
            {/* How to Enter */}
            <div className="flex items-center gap-2 mb-2">
              <div className="flex items-center gap-1 bg-white/5 px-1.5 py-0.5 rounded-full border border-white/10">
                <Instagram className="w-2 h-2 text-[#FFD700]" />
                <span className="text-white text-[7px]">Follow</span>
              </div>
              <div className="flex items-center gap-1 bg-white/5 px-1.5 py-0.5 rounded-full border border-white/10">
                <Share2 className="w-2 h-2 text-[#FFD700]" />
                <span className="text-white text-[7px]">Share</span>
              </div>
              <div className="flex items-center gap-1 bg-white/5 px-1.5 py-0.5 rounded-full border border-white/10">
                <MessageCircle className="w-2 h-2 text-[#FFD700]" />
                <span className="text-white text-[7px]">DM Us</span>
              </div>
            </div>
            
            <p className="text-[#FFD700] font-semibold text-sm">@kingofit.ca</p>
          </div>
          
          {/* Right Side - Prize Card */}
          <div className="relative bg-gradient-to-br from-[#1a2030] to-[#0f141c] rounded-xl p-4 border border-[#FFD700]/20 shadow-xl w-[190px]">
            {/* Trophy Icon */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 bg-gradient-to-br from-[#FFD700] to-[#FFA500] rounded-full flex items-center justify-center shadow-lg">
              <Trophy className="w-3 h-3 text-[#0f1219]" />
            </div>
            
            <div className="pt-2 text-center">
              <p className="text-[#8B9A46] text-[6px] font-medium mb-0.5">GRAND PRIZE</p>
              <p className="text-3xl font-black text-[#FFD700] mb-0.5" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>$100</p>
              <p className="text-white text-sm font-light" style={{ fontFamily: "'Playfair Display', serif" }}>Gift Card</p>
              
              <div className="mt-2 pt-2 border-t border-white/10">
                <p className="text-gray-400 text-[6px] mb-1">Redeemable at</p>
                <div className="flex items-center justify-center gap-1">
                  <div className="w-3 h-3 bg-[#8B9A46]/30 rounded-full flex items-center justify-center">
                    <Gift className="w-1.5 h-1.5 text-[#A4B55C]" />
                  </div>
                  <span className="text-white text-[10px]" style={{ fontFamily: "'Playfair Display', serif" }}>Olive Branch</span>
                </div>
                <div className="flex items-center justify-center gap-0.5 mt-0.5 text-gray-500 text-[6px]">
                  <MapPin className="w-1.5 h-1.5" />
                  <span>Promenade Mall</span>
                </div>
              </div>
              
              <div className="mt-2 pt-2 border-t border-white/10">
                <div className="flex items-center justify-center gap-1 text-white text-[8px]">
                  <Calendar className="w-2 h-2 text-[#FFD700]" />
                  <span>Draw: <span className="text-[#FFD700] font-semibold">Jan 25, 2026</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacebookPoster;
